// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.info[data-v-48a7ea27] {\n\tbackground: #fcef91;\n\ttop: 0;\n\twidth: 100%;\n\theight: 35px;\n\tborder-bottom: 1px solid #cece3d;\n\ttext-align: center;\n\tline-height: 35px;\n\tcolor: #615b2b;\n\tz-index: 1;\n\tposition: absolute;\n\tz-index: 1;\n}\n.info .w-link[data-v-48a7ea27] {\n\ttext-decoration: underline;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
